import type { ComponentProps, FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { LEARN_MORE_LINK } from '../constants.ts';

type GuestLearnMoreLinkProps = ComponentProps<typeof LearnMoreLink>;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LearnMoreLink = styled.a({
	color: 'inherit',
	textDecoration: 'underline',

	'&:visited': {
		color: 'inherit',
	},
});

const i18n = defineMessages({
	learnMore: {
		id: 'external-collab-ui.learn-more',
		defaultMessage: 'Learn more',
		description: 'Link text to learn more about guest mode',
	},
});

export const GuestLearnMoreLink: FC<GuestLearnMoreLinkProps> = ({ children, onClick }) => {
	return (
		<LearnMoreLink onClick={onClick} href={LEARN_MORE_LINK} target="_blank">
			{children || <FormattedMessage {...i18n.learnMore} />}
		</LearnMoreLink>
	);
};
